import { PUBLIC_URL, PLACEHOLDER_IMAGE } from "../config/api";

const isAbsoluteUrl = (url) => /^(https?:)?\/\//i.test(url) || /^data:|^blob:/i.test(url);

export const resolvePublicImageUrl = (imageUrl) => {
  if (!imageUrl) return "";
  const trimmed = String(imageUrl).trim();
  if (!trimmed) return "";
  if (isAbsoluteUrl(trimmed)) return trimmed;
  if (trimmed.startsWith(PUBLIC_URL)) return trimmed;
  const cleaned = trimmed.replace(/^\/+/, "");
  return `${PUBLIC_URL}/${cleaned}`;
};

export const DUMMY_IMAGE = resolvePublicImageUrl("dummy.jpg");

export const withFallbackImage = (imageUrl) => resolvePublicImageUrl(imageUrl) || DUMMY_IMAGE;

export const handleImageFallback = (event) => {
  const img = event?.currentTarget;
  if (!img) return;
  if (img.dataset.fallbackApplied === "1") return;
  img.dataset.fallbackApplied = "1";
  img.src = DUMMY_IMAGE;
};
